import _ from 'underscore';

function dataURItoBlob(dataURI) {
  const reg = /:(.+?);/;
  const arrs = dataURI.split(',');
  const header = _.first(arrs);
  const content = _.last(arrs);
  let type = 'image/png';

  const byteString = atob(content);
  const array = new Uint8Array(byteString.length);

  for (let i = 0; i < byteString.length; i += 1) {
    array[i] = byteString.charCodeAt(i);
  }
  if (reg.test(header)) {
    type = header.match(reg)[1];
  }
  return new Blob([array], { type });
}

/**
 * Convert image string to File object
 * @param {string} img image string to be convertImage2File
 * @param {string} name file name of image
 * @returns {File} File object
 */
export function convertImage2File(img, name) {
  const blob = dataURItoBlob(img);
  const postfix = _.last(blob.type.split('/'));
  return new File([blob], `${name}.${postfix}`, { type: blob.type, lastModified: Date.now() });
}



// WEBPACK FOOTER //
// ./d:/dbs/el/aapusc/private/client/packages/primitive-utilities/src/file.es